import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { useTranslation } from "react-i18next";

export function NoProductFound({ trans_key }) {
	const { t } = useTranslation();
	const iconSize = 64;

	const transKeyOverview = `${trans_key}.manage.overview`;
	return (
		<Grid container alignItems="center" justifyContent="center" sx={{ my: 10 }}>
			<Grid item xs={10} md={6} lg={4}>
				<Box textAlign="center">
					<SearchOffIcon sx={{ height: iconSize, width: iconSize }} />

					<Typography fontWeight={500} fontSize={18} color="grey.light">
						{t(`${transKeyOverview}.empty`)}
					</Typography>

					<Link href={`/${trans_key}/create`} passHref>
						<Button
							color="secondary"
							endIcon={<ArrowForwardIcon />}
							variant="outlined"
							sx={{ mt: 2, width: { lg: "auto", xs: "100%" } }}
						>
							{t(`${transKeyOverview}.bttn_create`)}
						</Button>
					</Link>
				</Box>
			</Grid>
		</Grid>
	);
}
